<div class="request-form">
    <h4 mat-h4>Request Details</h4>
    <p class="intro">
        Tell us what needs doing in your own words. There is no need to work out who deals with it —
        we will read it, work that out, and come back to you.
    </p>
    <table width="100%">
        <tr>
            <td>
                <app-ctl-holder [control]="unitCtl"></app-ctl-holder>
            </td>
        </tr>
        <tr>
            <td>
                <app-ctl-holder [control]="titleCtl"></app-ctl-holder>
            </td>
        </tr>
        <tr>
            <td>
                <app-ctl-holder [control]="descriptionCtl"></app-ctl-holder>
            </td>
        </tr>
        <tr>
            <td>
                <button (click)="postNewRequest()" [disabled]="submitting" mat-raised-button color="primary">
                    Submit
                </button>
            </td>
        </tr>
    </table>

    @if (submitting) {
        <div class="analysing">
            <mat-spinner diameter="28"></mat-spinner>
            <p>
                Reading your request and checking what we already know about your development.
                This takes a few moments — please do not reload the page.
            </p>
        </div>
    }
</div>
